import { stage } from 'config/stage';

const login = {
    prd: 'https://login.nextcloud.aero',
    test: 'https://login-test.nextcloud.aero',
    dev: 'https://login-dev.nextcloud.aero',
    cloud9: process.env.REACT_APP_HOST,
    ide: ['https://localhost', 8080].join(':'),
};

export default login[stage];
